import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CookieConsentService } from '../../../core/services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.html',
  styleUrl: './cookie-consent.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsent {
  protected readonly consent = inject(CookieConsentService);
  protected changeAnalytics(event: Event): void {
    this.consent.draftAnalytics.set((event.target as HTMLInputElement).checked);
  }
}
